export const POST_GET_ALL_SERIES_REQUEST = 'POST_GET_ALL_SERIES_REQUEST' as const;
export const POST_GET_ALL_SERIES_SUCCESS = 'POST_GET_ALL_SERIES_SUCCESS' as const;
export const POST_GET_ALL_SERIES_ERROR = 'POST_GET_ALL_SERIES_ERROR' as const;

export const POST_UNRESERVE_MARKING_CODE_REQUEST = 'POST_UNRESERVE_MARKING_CODE_REQUEST' as const;
export const POST_UNRESERVE_MARKING_CODE_SUCCESS = 'POST_UNRESERVE_MARKING_CODE_SUCCESS' as const;
export const POST_UNRESERVE_MARKING_CODE_ERROR = 'POST_UNRESERVE_MARKING_CODE_ERROR' as const;

export const POST_GET_SERIES_DETAILED_REQUEST = 'POST_GET_SERIES_DETAILED_REQUEST' as const;
export const POST_GET_SERIES_DETAILED_SUCCESS = 'POST_GET_SERIES_DETAILED_SUCCESS' as const;
export const POST_GET_SERIES_DETAILED_ERROR = 'POST_GET_SERIES_DETAILED_ERROR' as const;

export const CLOSE_ERROR_POPUP_SERIES = 'CLOSE_ERROR_POPUP_SERIES' as const;
